import React from 'react';
import { useTranslation } from 'react-i18next';

function FastDelivery() {
    const { t } = useTranslation();
    return (
        <section className="">
            <div className="tf-container">
                <div className="row justify-content-center">

                    {/* Titre */}
                    <div className="col-md-12 text-center">
                        <div className="tf-heading my-5 wow fadeInUp">
                            <h2 className="heading" style={{ textAlign: "center" }}>
                                {t('Fast FC Coins Delivery')}
                            </h2>
                        </div>
                    </div>

                    {/* Image - Centrée et 8 colonnes */}
                    <div className="col-md-12 text-center" data-aos="fade-up" data-aos-duration="800">
                    <p className="content-text" style={{ fontSize: "16px" }}>
                                {t("Why wait when you can get your **FC Coins instantly**?")}
                            </p>
                            <p className="content-text" style={{ fontSize: "16px" }}>
                                {t("Notre **système de livraison automatisé** garantit que vous recevez vos pièces **en quelques minutes** après votre achat.")}
                            </p>
                    </div>

                    {/* Contenu principal */}
                    <div className="col-md-12 mt-4">
                        <div className="content-box" style={{ padding: "20px", borderRadius: "10px", boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.1)" }}>
                            
                        <div className="content-box w-100" style={{ padding: "20px", borderRadius: "10px", boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.1)" }}>
                            <img 
                                src="images/pages/fc5.jpg" 
                                alt="Fast FC Coins Delivery" 
                                className="img-fluid" 
                                style={{ width: "100%", maxHeight: "500px", borderRadius: "8px" }} 
                            />
                        </div>
                            {/* <h3 className="content-title" style={{ fontSize: "20px", fontWeight: "600" }}>
                                {t('Instant FC Coins Delivery')}
                            </h3> */}
                           
                            <h3 className="content-title" style={{ fontSize: "20px", fontWeight: "600" }}>
                                {t('Automated System')}
                            </h3>
                            <p className="content-text" style={{ fontSize: "16px" }}>
                                {t("Our **fully automated system** processes orders in real time, so you don't have to wait for them.")}
                            </p>
                            <p className="content-text" style={{ fontSize: "16px" }}>
                                {t("Whether you buy **late at night or during peak hours**, our system is designed to process your request efficiently and deliver **instant FC Coins to your account**.")}
                            </p>

                            <h3 className="content-title" style={{ fontSize: "20px", fontWeight: "600" }}>
                                {t('Secure and risk-free transfers')}
                            </h3>
                            <p className="content-text" style={{ fontSize: "16px" }}>
                                {t("Speed should never come at the expense of security.")}
                            </p>
                            <p className="content-text" style={{ fontSize: "16px" }}>
                                {t("That's why our **fast delivery system** also follows strict security measures to ensure the security of your account.")}
                            </p>

                            <h3 className="content-title" style={{ fontSize: "20px", fontWeight: "600" }}>
                                {t('Ultra-fast processing')}
                            </h3>
                            <p className="content-text" style={{ fontSize: "16px" }}>
                                {t("Our system guarantees that orders are processed **instantly**, most purchases being **completed in less than 5 minutes**.")}
                            </p>
                            <p className="content-text" style={{ fontSize: "16px" }}>
                                {t("Don't waste time waiting—**receive your FC Coins instantly** and enjoy the game **without delays**!")}
                            </p>

                            <h3 className="content-title" style={{ fontSize: "20px", fontWeight: "600" }}>
                                {t('Client assistance 24/7')}
                            </h3>
                            <p className="content-text" style={{ fontSize: "16px" }}>
                                {t("Need_assistance")}
                            </p>
                            <p className="content-text" style={{ fontSize: "16px" }}>
                                {t("Contact us at any time via **live chat, email, or phone**, and our team will provide you with **quick and professional assistance**.")}
                            </p>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
}

export default FastDelivery;
